import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  isEmpty,
  isLoaded,
  populate,
  firestoreConnect,
} from 'react-redux-firebase';

import Snackbar from '../../components/Snackbar';

import MainTitle from '../../components/MainTitle';
import TabInversion from '../../components/TabInvesion/';
import MyMembership from '../../components/MyMembership';
import PopupCancel from '../../components/Modal/PopupCancel';
import BillingTable from '../../components/Tables/BillingTable';
import ButtonNormal from '../../components/Buttons/ButtonNormal';
import BillingList from '../../components/MyMembership/Billing/components/BillingList';
//import { getBillingLaywers } from "../../store/actions/billingAction";

import './index.scss';
import { Invoices } from '../Invoicing/Invoices';


class Memberships extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      anchorEl: null,
      docs: [],
      feedbackMessage: {
        open: false,
        message: '',
        variant: 'info',
      },
      notificationWillBeTriggered: {
        id: '',
        read: false,
        featured: false,
      },
      openModalDelete: false,
      tabValue: 0,
      open: false,
    };
  }

  componentWillMount(){
    //this.getBilling()
  }

  handleChange(newValue) {
    this.setState({ tabValue: newValue });
  }

  /* getBilling = async() => {
    let data = await this.props.getBillingLaywers(this.props.uid);
  } */

  printTitle = (tabValue) => {
    let title = '';
    switch (tabValue) {
      case 0:
        title = (
          <MainTitle
            title="Membresía"
            subtitle="Obtén toda la información que necesitas acerca de tu membresía"
          />
        );
        break;

      case 1:
        title = (
          <MainTitle
            title="Historial de pago"
            subtitle="Obtén toda la información que necesitas acerca de tus pagos"
          />
        );
        break;
      case 2:
        title = (
          <MainTitle
            title="Formas de pago"
            subtitle="Obtén toda la información que necesitas acerca de tus métodos de pago agregados a la plataforma"
          />
        );
        break;
      case 3:
        title = (
          <MainTitle
            title="Facturas emitidas"
            subtitle="Obtén toda la información de tus facturas"
          />
        );
        break;

      default:
        title = '';
        break;
    }
    return title;
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { notifications, stateNotifications, billing, membershipType, suscription   } = this.props;
    const {
      anchorEl,
      notificationWillBeTriggered,
      feedbackMessage,
      openModalDelete,
    } = this.state;

    const myMembershipView = true;

    return (
      <div className="memberships-section">
        {!myMembershipView && (
          <>
            <div className="memberships-section-title">
              <p>Tipos de Membresía</p>
              <p>
                100.000 profesionales ya están en Contacta Abogado ¿y usted?
              </p>
            </div>
            <TabInversion />
          </>
        )}

        {myMembershipView && (
          <>
            <div className="memberships-section-withTabs">
              <div className="memberships-section-withTabsTitle">
                {this.printTitle(this.state.tabValue)}
              </div>

              <div>
                <MyMembership
                  billing={billing}
                  value={this.state.tabValue}
                  suscription={suscription}
                  handleChange={this.handleChange}
                />

                {/* Cancelar membresía */}

                {this.state.tabValue === 0 && (
                  //Botón cancelar para cuenta premium y plus
                  <div className="memberships-section-cancel">
                    {membershipType !== 'Free' ?
                      <button onClick={(e) => this.setState({ open: true })}>
                        Cancelar membresía
                      </button> : null
                    }
                    <PopupCancel
                      open={this.state.open}
                      handleClose={this.handleClose}
                      title={'Cancelar membresía'}
                      subtitle={
                        <span>
                          Para cancelar tu membresía llama a nuestro centro de
                          customer experience al <br />
                          <b>52 55 4160 6061</b>
                          <br />o envíanos un mail a <br />
                          <b>hola@contactaabogado.com</b>
                        </span>
                      }
                      primaryButton={true}
                      primaryButtonVariant="primary"
                      primaryButtonText="Entendido"
                      primaryFunction={this.handleClose}
                    />
                  </div>
                )}

                {/* Componente de facturas debajo de tabs */}

                {this.state.tabValue === 3 && membershipType !== 'Free' && (
                     <Invoices  billing={billing && billing.invoices}/>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  //getBillingLaywers: (uid) => dispatch(getBillingLaywers(uid)),
})

const mapStateToProps = state => ({
  uid: state.authClient.uid,
  membershipType: state.authClient.membership.type
})

export default connect(mapStateToProps,mapDispatchToProps)(Memberships);
